import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';

const Footer: React.FC = () => (
  <Box component="footer" sx={{ bgcolor: 'background.paper', py: 6 }}>
    <Container maxWidth="lg">
      <Typography variant="body2" color="text.secondary" align="center">
        © {new Date().getFullYear()} MyCoderZone. All rights reserved.
      </Typography>
      <Typography variant="body2" color="text.secondary" align="center">
        <Button color="inherit">Privacy Policy</Button>
        <Button color="inherit">Terms of Service</Button>
      </Typography>
    </Container>
  </Box>
);

export default Footer;
